// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../picture/download.avif", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/src/picture/AMETHYST-LOGO-removebg-preview.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Header css */

:root {
    --bg-oficial: #b4a45b;
    --font-body: 'Kanit', sans-serif;
}

.activenav:hover {
    color: #69E4FF;
}

.container-main {
    background-color: #ffffff;
    /* Background color for the container */
    margin: 4%;
    padding: 2%;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
    margin-left: 10%;
    height: auto;
    background-image: linear-gradient(#E6E8EA, rgb(255, 255, 255));
    border-radius: 10px;
}
.forgot-password {
    color: blue; /* ตัวหนังสือเป็นสีน้ำเงิน */
    cursor: pointer;
    width: 35%;
    height: 21px;
    text-decoration: none; /* ปิดเส้นใต้ปกติ */
    transition: color 0.01s ease-in-out, -webkit-text-decoration 0.01s ease-in-out;
    transition: color 0.01s ease-in-out, text-decoration 0.01s ease-in-out;
    transition: color 0.01s ease-in-out, text-decoration 0.01s ease-in-out, -webkit-text-decoration 0.01s ease-in-out;
  }
  
  .forgot-password:hover {
    color: lightblue; /* เปลี่ยนเป็นสีอ่อนลงเมื่อ hover */
    text-decoration: underline; /* เพิ่มเส้นใต้เมื่อ hover */
  }
.bd-navbar {
    min-height: 0rem;
    background-color: var(--bg-oficial);
    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, .05), inset 0 -1px 0 rgba(0, 0, 0, .1);
    padding-top: 2em;
    padding-bottom: .5em;

}

.title-navbar {
    font-family: var(--font-body);
    font-weight: 800;
    font-size: 45px;
}

.subtitle-section {
    color: var(--bg-oficial);
    font-family: var(--font-body);
    font-weight: 600;
    font-size: 25px;
}

.subtitle-card {
    font-family: var(--font-body);
    font-weight: 600;
    font-size: 25px;
}

.text-center {
    text-align: center;
}

.container-general {
    display: flex;
    align-items: center;
}

.section-container {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    border: 1px solid #c8c8c8;
}

.section-left {
    border-bottom-left-radius: 16px;
}

.section-right {
    border-bottom-right-radius: 16px;
}

.container-box {
    padding-left: 0;
    padding-right: 0;
}

.form-element {
    margin: 5px;
    min-width: 200px;
}


/*.form-control {
    width: 238px;
    display: block;
    border: 1px solid #C4B4B4;
    border-radius: 20px;
    height: 38px;
    padding: 5px 10px 5px 40px;
    
}*/

.form-box {
    width: 100%;
    max-width: 285px;
    border-radius: 10px;
}

.form-label {
    min-width: 150px;
    display: block;
    font-family: var(--font-body);
    font-weight: 600;
}

.input-display {
    display: inline-block;
    border: 1px solid #C4B4B4;
    border-radius: 10px;
    height: 40px;
    padding: 5px 10px 5px 15px;
}

.font-icon {
    position: relative;

}

.font-icon i {
    position: absolute;
    left: 15px;
    top: 45px;
    color: #000;

}

.font-icon1 {
    font-size: 60px;


}

.btn-generate {
    border: none;
    border-radius: 10px;
    background-color: var(--bg-oficial);
    color: #fff;
    font-family: var(--font-body);
    font-weight: bold;
    padding: .5em;
    margin-top: 1em;
}

.id-card-container {
    display: none;
}

.card-container {
    width: 90vw;
    height: 300px;
    border-radius: 10px;
    font-family: var(--font-body);
    display: flex;
    align-items: center;
    justify-content: center;
}

.card-title {
    font-size: 16px;
    color: #BABFC9;
    font-weight: bold;
}

.card-input {
    font-size: 16px;
    color: #515A67;
    font-weight: bold;
}

.card-input1 {
    font-size: 28px;
    color: #515A67;
    font-weight: bold;
    padding: 5px 10px 5px 10px;


}

.card-wrapper {
    width: 80vw;
    height: 250px;
    background-color: #fff;
    background: linear-gradient(#f8f8f8, #fff);
    box-shadow: 0 8px 16px -8px rgba(0, 0, 0, 0.4);
    border-radius: 10px;
    overflow: hidden;
    position: relative;
    margin: 1.5rem;
    display: flex;
}

.user-card {
    width: 30vw;
    height: 100%;
    position: relative;
    background: linear-gradient(to top, var(--bg-oficial), #8f94fb);
    display: flex;
    justify-content: center;
    align-items: center;
}

.general-information {
    width: 60vw;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    background-color: #F8F8F8;
}

.user-photo {
    font-size: 10em;
    color: white;
}

.card-element {
    margin-left: 10px;
    margin-bottom: 15px;
}

.card-name {
    font-size: 1.5rem;
}

.college-name {
    font-size: 1.2rem;
}

.font-cen {
    font-Family: "Kanit"
}

.backgroundbase {
    /* background: linear-gradient(94.35deg, #023E8A 0%, #0077B6 100%); */
}

.build-button-border {

    padding: 1rem;
    position: relative;
    background: linear-gradient(101.27deg, #E01E37 0%, #FF792B 100%);
    padding: 3px;
}

.buildbutton {
    background: #E6E8EA;
    color: black;

}


.btnlogin {
    top: 420px;
    left: 25px;
    width: 350px;
    height: 60px;
    border-radius: 100px;
    background-color: #023E8A;
    color: #FFFFFF;
    font-size: 26px;
    opacity: 0.6;
    transition: 0.3s;
}

.btnlogin:hover {
    opacity: 1
}




.frame {
    width: 90%;
    margin: 40px auto;
    text-align: center;
}

.custom-btn {

    color: #fff;
    border-radius: 5px;
    padding: 10px 25px;
    font-family: 'Lato', sans-serif;
    font-weight: 500;
    background: transparent;
    cursor: pointer;
    transition: all 0.3s ease;
    position: relative;
    display: inline-block;
    box-shadow: inset 2px 2px 2px 0px rgba(255, 255, 255, .5),
        7px 7px 20px 0px rgba(0, 0, 0, .1),
        4px 4px 5px 0px rgba(0, 0, 0, .1);
    outline: none;
}

.btnSave {
    background-image: linear-gradient(90deg, #61028a 0%, #5d00c7 100%);
    border: none;
    z-index: 1;
    opacity: 0.85;
    font-family: Kanit;
    font-size: 20px;
    border-radius: 25px;
}

.btnConfirm {
    background-image: linear-gradient(90deg, #006e1a 0%, #01b34b 100%);
    border: none;
    z-index: 1;
    opacity: 0.85;
    font-family: Kanit;
    font-size: 20px;
    border-radius: 25px;
}

.btnCancel {
    background-image: linear-gradient(97.41deg, #a50104 0%, #ff792b 100%);
    border: none;
    z-index: 1;
    opacity: 0.85;
    font-family: Kanit;
    font-size: 20px;
    border-radius: 25px;
}

.btnEdit2 {
    background-image: linear-gradient(97.29deg, #ffb300 0%, #ffe923 100%);
    border: none;
    z-index: 1;
    opacity: 0.85;
    font-family: Kanit;
    font-size: 20px;
    border-radius: 25px;
}

.btnDisable {
    background-image: linear-gradient(90.27deg, rgb(182, 182, 182) 0.23%, rgb(119, 119, 119) 99.42%);
    border: none;
    z-index: 1;
    opacity: 0.85;
    font-family: Kanit;
    font-size: 20px;
    border-radius: 25px;
}

.btnSave:after {
    position: absolute;
    content: "";
    width: 0;
    height: 100%;
    top: 0;
    right: 0;
    z-index: -1;
    background-image: linear-gradient(90deg, #61028a36 0%, #5d00c742 100%);
    border-radius: 25px;
    box-shadow: inset 2px 2px 2px 0px rgba(255, 255, 255, .5),
        7px 7px 20px 0px rgba(0, 0, 0, .1),
        4px 4px 5px 0px rgba(0, 0, 0, .1);
    transition: all 0.3s ease;

}

.btnConfirm:after {
    position: absolute;
    content: "";
    width: 0;
    height: 100%;
    top: 0;
    right: 0;
    z-index: -1;
    background-image: linear-gradient(90deg, #01b34b 0%, #006e1a 100%);
    border-radius: 25px;
    box-shadow: inset 2px 2px 2px 0px rgba(255, 255, 255, .5),
        7px 7px 20px 0px rgba(0, 0, 0, .1),
        4px 4px 5px 0px rgba(0, 0, 0, .1);
    transition: all 0.3s ease;

}

.btnCancel:after {
    background-image: linear-gradient(97.41deg, #a50104 0%, #ff792b 100%);
    position: absolute;
    content: "";
    width: 0;
    height: 100%;
    top: 0;
    right: 0;
    z-index: -1;
    border-radius: 25px;
    box-shadow: inset 2px 2px 2px 0px rgba(255, 255, 255, .5),
        7px 7px 20px 0px rgba(0, 0, 0, .1),
        4px 4px 5px 0px rgba(0, 0, 0, .1);
    transition: all 0.3s ease;

}

.btnEdit2:after {
    background-image: linear-gradient(97.29deg, #ffb710 0%, #ffeb34 100%);
    position: absolute;
    content: "";
    width: 0;
    height: 100%;
    top: 0;
    right: 0;
    z-index: -1;
    border-radius: 25px;
    box-shadow: inset 2px 2px 2px 0px rgba(255, 255, 255, .5),
        7px 7px 20px 0px rgba(0, 0, 0, .1),
        4px 4px 5px 0px rgba(0, 0, 0, .1);
    transition: all 0.3s ease;
}

.btnSave:hover {
    color: #ffffff;
    opacity: 1;
    border-radius: 25px;
}

.btnConfirm:hover {
    color: #ffffff;
    opacity: 1;
    border-radius: 25px;
}

.btnCancel:hover {
    color: #ffffff;
    opacity: 1;
    border-radius: 25px;
}

.btnEdit2:hover {
    color: #ffffff;
    opacity: 1;
    border-radius: 25px;
}

.btnSave:hover:after {
    left: 0;
    width: 100%;
}

.btnConfirm:hover:after {
    left: 0;
    width: 100%;
}

.btnCancel:hover:after {
    left: 0;
    width: 100%;
}

.btnEdit2:hover:after {
    left: 0;
    width: 100%;
}

.btnSave:active {
    top: 2px;
}

.btnConfirm:active {
    top: 2px;
}

.btnCancel:active {
    top: 2px;
}

.btnEdit2:active {
    top: 2px;
}



.dropdown {

    transition-duration: 0.7s;
    transition-delay: 0.3;

}

.dropdown-content {
    display: none;
    position: absolute;
    background-color: #f70a0a;
    min-width: 160px;
    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
    padding: 12px 16px;
    z-index: 1;
}

.dropdown:hover .dropdown-content {
    display: block;
    background-color: #f70a0a;
}

div .nav-section {
    color: #fff;
    /* Link text color */
    text-decoration: none;
    /* Remove default underline */
    display: inline-block;
}

div .nav-section:hover {
    border-bottom: 3.5px solid white;
    /* White line at the bottom */
}

.logo-text {
    color: #ffffff;
    font-family: 'Kanit';
    font-style: normal;
    font-weight: 700;
    font-size: 36px;
    line-height: 40px;
    padding-top: 3px;
}

.logo-text:hover {
    color: #7edcfc;
}

.card-box-login {
    top: 100px;
    width: 420px;
    height: auto;
    font-family: 'Kanit';
    padding: 20px 25px 30px;
    border-radius: 20px;
    background: white;
}

.main-bg {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    object-fit: cover;
    margin-left: auto;
    margin-right: auto;
    display: flex;
    width: 100%;
    height: 93.25vh;
    background-attachment: scroll;
    min-width: 980px;
}

.carousel-element {
    float: center;
    margin-top: 300px;
    background-color: white;
    width: 60%;
}

.center-box {
    margin-top: 5%;
    margin-left: 10%;
    margin-right: 10%;
    margin-bottom: 5%;
    align-items: center;
    width: 90%;
    height: auto;
    padding: 2%;
    background-color: rgba(46, 46, 46, 0.5);
    border-radius: 20px;
    max-height: 820px;

}

.center-text {
    color: white;
    margin: auto;
    font-size: 16px;
    padding-top: 2%;
    padding-left: 15%;
    padding-right: 15%;
    width: 100%;
    height: 100%;
    background-color: rgba(58, 58, 58, 0);

}

.center-carousel-main {
    width: auto;
    height: 105%;
    margin-bottom: 5%;
    margin-left: 4%;
    display: flex;
}

.center-img {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-size: cover;
    background-position: center center;
    transform: translate(0%, 0%);
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 20px;
    display: flex;
    width: 300px;
    height: 110px;
    background-attachment: scroll;
}

.center-img img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
}

.loading-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 85vh;
}

.check-box {
    color: black;

}

.check-box:hover {
    color: gray;
}

div.card-noti-content {
    margin: 10px 25px;
}

div.card-noti-header {
    display: flex;
    justify-content: space-between;
    /* Distribute items along the main axis */
    align-items: center;
    margin: 10px 2px;
    color: white;
}

.card-noti-header h5 {
    margin: 0;
    /* Remove default margin */
    text-align: center;
    /* Center text horizontally */
    flex: 1 1;
    /* Allow the h5 element to grow and fill available space */
}

.bin-icon {
    width: 25px;
    height: 25px;
    cursor: pointer;
    color: black;
    transition: 0.7s;
}

.bin-icon:hover {
    color: white;
    transition: 0.7s;
}

.card-noti-box {
    position: fixed;
    bottom: 60px;
    right: 50px;
    margin: auto;
    width: 400px;
    height: auto;
    min-height: 8vh;
    max-height: 40vh;
    overflow-y: auto;
    overflow-x: hidden;
    background-color: #60dfff;
    background: linear-gradient(90.27deg, rgb(2, 62, 138) 0.23%, rgb(0, 150, 199) 99.42%);
    box-shadow: 0 8px 10px 3px rgba(0, 0, 0, 0.4);
    border-radius: 15px;
    transition: 0.3s ease-in-out;
    z-index: 100;

}

.noti-bell-box {
    margin: 12px 50px 0px 0px;
    cursor: pointer;
    position: fixed;
    bottom: 10px;
    right: -30px;
    background-color: rgb(255, 255, 255);
    padding: 10px 20px;
    border-radius: 5px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    z-index: 100;
}

.noti-bell-box:hover .noti-bell-span,
.noti-bell-box:hover .noti-bell {
    color: #7edcfc;
}

.notification-item.removing {
    transition: 0.5s ease-in-out;
    /* Example transition */
    opacity: 0;
    /* Fade out the item */
}

.noti-bell {
    width: 25px;
    height: 25px;
    color: rgb(51, 103, 170);
    z-index: 0;
    transition: 0.5s;
}

.noti-bell-span {
    position: absolute;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    background-color: red;
    font-size: 10px;
    z-index: 1;
}


::-webkit-scrollbar {
    width: 7px;
}

::-webkit-scrollbar-thumb {
    background-color: #888;
    border-radius: 5px;
}


@media screen and (max-width: 1180px) {

    .profile-container {
        box-sizing: border-box;
        width: auto;
        height: auto;
        min-height: calc(100vh - 230px - 35px);
        max-width: 1230px;

    }

    .article-content {
        width: 80%;
        float: right;
        position: relative;
        box-sizing: border-box;
    }

    .profile-side-nav {
        width: 20%;
        height: 482px;
        margin-top: 161.5px;
        float: left;
        background: white;
        max-width: 280px;
        border-top: 2px solid #555;
    }

    .nav-side-body {
        background-color: #E6E8EA;
        width: 20%;
        height: 484px;
    }

    .nav-side-menu {
        width: 20%;
        height: 482px;
        margin: 0;
        padding: 0;
    }

    .nav-sidemenu-display {}

    .nav-sidemenu-selection {
        height: 45px;
        padding: 0px 36px 0px 20px;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        box-sizing: border-box;
        border-top: 1px solid #dfdfdf;
        font-size: 16px;
        color: #0077B6;
        font-weight: 400;
    }

    .nav-sidemenu-selection:hover {
        height: 45px;
        padding: 0px 36px 0px 20px;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        box-sizing: border-box;
        border-top: 1px solid #dfdfdf;
        font-size: 16px;
        color: #4d6368;
        font-weight: 400;
    }

    .nav-sidemenu-selection:active {
        height: 45px;
        padding: 0px 36px 0px 20px;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        box-sizing: border-box;
        border-top: 1px solid #dfdfdf;
        font-size: 16px;
        color: #4d6368;
        font-weight: 400;
    }

    li {
        list-style: none;
    }

    i {
        margin-right: 18px;
        width: 30px;
    }

    .profile-header {
        width: 880px;
        height: 163px;
        padding: 65px 0px 42px;
        font-size: 45px;
        color: #0077B6;
        text-align: center;
        border-bottom: 2px solid #555;

    }

    .user-main {
        margin-top: 20px;
        color: rgba(60, 60, 60, 1);
        display: block;
    }

    .user-wrap {
        width: 580px;
        height: 135px;
        color: white;
        background: #000;
        position: relative;
        display: flex;
        justify-content: center;
        flex-direction: column;
        padding: 22px 30px 22px 160px;
        border-radius: 15px;
        background: #353942;
        box-sizing: border-box;
    }

    .user-deshboard {

        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
        width: 880px;
        height: auto;
        margin-top: 18px;
    }

    .user-desh-left {
        float: left;
        display: block;
        width: 50%;
        box-sizing: border-box;
        padding: 0px 10px 0px 0px;
    }

    .user-desh-right {
        width: 50%;
        float: right;
        display: block;
        box-sizing: border-box;
        padding: 0px 0px 0px 10px;
    }

    .user-desh-box {
        vertical-align: baseline;
        width: 430px;
        height: auto;
        padding: 25px 29px;
        min-inline-size: auto;
        background-color: white;
        border-radius: 6px;
    }

    .user-icon {
        position: absolute;
        margin: auto;
        left: 45px;
        top: 50%;
        width: 80px;
        height: 80px;
        transform: translate3d(0, -50%, 0);
    }

    .icon-character {
        width: 100%;
        height: 100%;
        margin-top: 10px;
        margin: auto;
        background-color: #023E8A;
        text-align: center;
        font-size: 50px;
        color: white;
        border-radius: 50%;
        display: block;
        box-sizing: border-box;
    }

    .acount {}

    .logged {
        margin: 18px 0px 0px;
    }

    .secure {
        margin: 18px 0px 0px;
    }

    .secure_list {
        margin-top: 5px;
        padding-left: 5px;
        overflow: hidden;
    }

    .secure_list .item {
        font-size: 0.92rem;
    }

    .secure_list .btn_secure {
        position: absolute;
        right: 0;
        top: 50%;
        display: flex;
        border-radius: 50%;
        transform: translate3d(0, -50%, 0);
        box-sizing: border-box;
        cursor: default;
    }

    .icn_svg {
        flex: 0 0 auto;
        display: inline-block;
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
    }

    

}

@media screen and (min-width: 1180px) {

    .profile-container {
        margin: 0px auto;
        padding: 0px 0px 80px;
        box-sizing: border-box;
        width: auto;
        height: auto;
        min-height: calc(100vh - 230px - 35px);
        max-width: 1230px;
        display: flex;
    }

    .article-content {
        width: 100%;
        max-width: 880px;
        margin: 0px auto;
        float: right;
        position: relative;
        box-sizing: border-box;
    }

    .profile-side-nav {

        width: auto;
        height: 482px;
        margin-top: 161.5px;
        float: left;
        background: white;
        max-width: 280px;
        border-top: 2px solid #555;
    }

    .nav-side-body {
        background-color: #E6E8EA;
        width: 280px;
        height: 484px;
    }

    .nav-side-menu {
        width: 280px;
        height: 482px;
        margin: 0;
        padding: 0;
    }

    .nav-sidemenu-display {}

    .nav-sidemenu-selection {
        height: 45px;
        padding: 0px 36px 0px 20px;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        box-sizing: border-box;
        border-top: 1px solid #dfdfdf;
        font-size: 16px;
        color: #0077B6;
        font-weight: 400;
    }

    .nav-sidemenu-selection:hover {
        height: 45px;
        padding: 0px 36px 0px 20px;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        box-sizing: border-box;
        border-top: 1px solid #dfdfdf;
        font-size: 16px;
        color: #4d6368;
        font-weight: 400;
    }

    .nav-sidemenu-selection:active {
        height: 45px;
        padding: 0px 36px 0px 20px;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        box-sizing: border-box;
        border-top: 1px solid #dfdfdf;
        font-size: 16px;
        color: #4d6368;
        font-weight: 400;
    }

    li {
        list-style: none;
    }

    i {
        margin-right: 18px;
        width: 30px;
    }



    .profile-header {
        width: 880px;
        height: 163px;
        padding: 65px 0px 42px;
        font-size: 45px;
        color: #0077B6;
        text-align: center;
        border-bottom: 2px solid #555;

    }

    .user-main {
        margin-top: 20px;
        color: rgba(60, 60, 60, 1);
        display: block;
    }

    .user-wrap {
        width: 880px;
        height: 135px;
        color: white;
        background: #000;
        position: relative;
        display: flex;
        justify-content: center;
        flex-direction: column;
        padding: 22px 30px 22px 160px;
        border-radius: 15px;
        background: #353942;
        box-sizing: border-box;
    }

    .user-deshboard {

        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
        width: 880px;
        height: auto;
        margin-top: 18px;
    }

    .user-desh-left {
        float: left;
        display: block;
        width: 50%;
        box-sizing: border-box;
        padding: 0px 10px 0px 0px;
    }

    .user-desh-right {
        width: 50%;
        float: right;
        display: block;
        box-sizing: border-box;
        padding: 0px 0px 0px 10px;
    }

    .user-desh-box {
        vertical-align: baseline;
        width: 430px;
        height: auto;
        padding: 25px 29px;
        min-inline-size: auto;
        background-color: rgba(255, 255, 255, 0.658);
        border-radius: 6px;
        box-shadow: 0px 4px 7px 1px rgba(0, 0, 0, 0.12);
    }

    .user-desh-title {
        position: relative;
    }

    .user-desh-content {}

    .user-icon {
        position: absolute;
        margin: auto;
        left: 45px;
        top: 50%;
        width: 80px;
        height: 80px;
        transform: translate3d(0, -50%, 0);
    }

    .btn-more {
        position: absolute;
        right: 0;
        top: 50%;
        width: 18px;
        height: 10px;
        padding: 8px 4px;
        opacity: 0.65;
        z-index: 5;
        transform: translate3d(-15%, -50%, 0);
        transition: opacity .25s ease;
    }


    .icon-character {
        width: 100%;
        height: 100%;
        margin-top: 10px;
        margin: auto;
        background-color: #023E8A;
        text-align: center;
        font-size: 50px;
        color: white;
        border-radius: 50%;
        display: block;
        box-sizing: border-box;
    }

    .icon-edit {
        transform: translate3d(0%, -15%, 0);
        cursor: pointer;
    }

    .icon-edit:hover {
        color: rgb(77, 99, 104);
    }

    .dash-more {
        position: absolute;
        left: 0;
        top: 50%;
        transform: translate3d(0, -50%, 0);
        color: gray;
    }

    .dash-more:hover {
        color: #0077B6;
    }

    .account {}

    .logged {
        margin: 18px 0px 0px;
    }

    .secure {
        margin: 18px 0px 0px;
    }

    .secure_list {
        margin-top: 5px;
        padding-left: 5px;
        overflow: hidden;
    }

    .secure_list .item {
        margin-top: 15px;
        position: relative;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        min-height: 28px;
        padding-right: 40px;
        font-size: 18px;
        box-sizing: border-box;
    }

    .secure_list .btn_secure {
        position: absolute;
        right: 0;
        top: 50%;
        display: flex;
        border-radius: 50%;
        transform: translate3d(0, -50%, 0);
        box-sizing: border-box;
        cursor: default;
    }

    .icn_svg {
        flex: 0 0 auto;
        display: inline-block;
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
    }

}`, "",{"version":3,"sources":["webpack://./src/Components/profile/Styles.css"],"names":[],"mappings":"AAAA,eAAe;;AAEf;IACI,qBAAqB;IACrB,gCAAgC;AACpC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,uCAAuC;IACvC,UAAU;IACV,WAAW;IACX,2CAA2C;IAC3C,gBAAgB;IAChB,YAAY;IACZ,8DAA8D;IAC9D,mBAAmB;AACvB;AACA;IACI,WAAW,EAAE,4BAA4B;IACzC,eAAe;IACf,UAAU;IACV,YAAY;IACZ,qBAAqB,EAAE,mBAAmB;IAC1C,8EAAsE;IAAtE,sEAAsE;IAAtE,iHAAsE;EACxE;;EAEA;IACE,gBAAgB,EAAE,mCAAmC;IACrD,0BAA0B,EAAE,4BAA4B;EAC1D;AACF;IACI,gBAAgB;IAChB,mCAAmC;IACnC,8EAA8E;IAC9E,gBAAgB;IAChB,oBAAoB;;AAExB;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,wBAAwB;IACxB,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;;AAGA;;;;;;;;EAQE;;AAEF;IACI,WAAW;IACX,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;;AAEtB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,WAAW;;AAEf;;AAEA;IACI,eAAe;;;AAGnB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,mCAAmC;IACnC,WAAW;IACX,6BAA6B;IAC7B,iBAAiB;IACjB,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,6BAA6B;IAC7B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,0BAA0B;;;AAG9B;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,0CAA0C;IAC1C,8CAA8C;IAC9C,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,+DAA+D;IAC/D,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI;AACJ;;AAEA;IACI,qEAAqE;AACzE;;AAEA;;IAEI,aAAa;IACb,kBAAkB;IAClB,gEAAgE;IAChE,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,YAAY;;AAEhB;;;AAGA;IACI,UAAU;IACV,UAAU;IACV,YAAY;IACZ,YAAY;IACZ,oBAAoB;IACpB,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI;AACJ;;;;;AAKA;IACI,UAAU;IACV,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;;IAEI,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,+BAA+B;IAC/B,gBAAgB;IAChB,uBAAuB;IACvB,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,qBAAqB;IACrB;;yCAEqC;IACrC,aAAa;AACjB;;AAEA;IACI,kEAAkE;IAClE,YAAY;IACZ,UAAU;IACV,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,kEAAkE;IAClE,YAAY;IACZ,UAAU;IACV,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,qEAAqE;IACrE,YAAY;IACZ,UAAU;IACV,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,qEAAqE;IACrE,YAAY;IACZ,UAAU;IACV,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,gGAAgG;IAChG,YAAY;IACZ,UAAU;IACV,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,YAAY;IACZ,MAAM;IACN,QAAQ;IACR,WAAW;IACX,sEAAsE;IACtE,mBAAmB;IACnB;;yCAEqC;IACrC,yBAAyB;;AAE7B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,YAAY;IACZ,MAAM;IACN,QAAQ;IACR,WAAW;IACX,kEAAkE;IAClE,mBAAmB;IACnB;;yCAEqC;IACrC,yBAAyB;;AAE7B;;AAEA;IACI,qEAAqE;IACrE,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,YAAY;IACZ,MAAM;IACN,QAAQ;IACR,WAAW;IACX,mBAAmB;IACnB;;yCAEqC;IACrC,yBAAyB;;AAE7B;;AAEA;IACI,qEAAqE;IACrE,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,YAAY;IACZ,MAAM;IACN,QAAQ;IACR,WAAW;IACX,mBAAmB;IACnB;;yCAEqC;IACrC,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,OAAO;IACP,WAAW;AACf;;AAEA;IACI,OAAO;IACP,WAAW;AACf;;AAEA;IACI,OAAO;IACP,WAAW;AACf;;AAEA;IACI,OAAO;IACP,WAAW;AACf;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,QAAQ;AACZ;;;;AAIA;;IAEI,yBAAyB;IACzB,qBAAqB;;AAEzB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;IAChB,+CAA+C;IAC/C,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,oBAAoB;IACpB,qBAAqB;IACrB,6BAA6B;IAC7B,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;IAChC,6BAA6B;AACjC;;AAEA;IACI,cAAc;IACd,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,YAAY;IACZ,oBAAoB;IACpB,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,mDAA8C;IAC9C,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,eAAe;IACf,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,uBAAuB;IACvB,UAAU;AACd;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;IACnB,UAAU;IACV,YAAY;IACZ,WAAW;IACX,uCAAuC;IACvC,mBAAmB;IACnB,iBAAiB;;AAErB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,qCAAqC;;AAEzC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,mDAAkE;IAClE,sBAAsB;IACtB,kCAAkC;IAClC,4BAA4B;IAC5B,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,YAAY;IACZ,aAAa;IACb,6BAA6B;AACjC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,YAAY;;AAEhB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,yCAAyC;IACzC,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,SAAS;IACT,0BAA0B;IAC1B,kBAAkB;IAClB,6BAA6B;IAC7B,SAAO;IACP,0DAA0D;AAC9D;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;IACzB,qFAAqF;IACrF,6CAA6C;IAC7C,mBAAmB;IACnB,4BAA4B;IAC5B,YAAY;;AAEhB;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf,eAAe;IACf,YAAY;IACZ,YAAY;IACZ,oCAAoC;IACpC,kBAAkB;IAClB,kBAAkB;IAClB,wCAAwC;IACxC,YAAY;AAChB;;AAEA;;IAEI,cAAc;AAClB;;AAEA;IACI,4BAA4B;IAC5B,uBAAuB;IACvB,UAAU;IACV,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,wBAAwB;IACxB,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,qBAAqB;IACrB,eAAe;IACf,UAAU;AACd;;;AAGA;IACI,UAAU;AACd;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;AACtB;;;AAGA;;IAEI;QACI,sBAAsB;QACtB,WAAW;QACX,YAAY;QACZ,sCAAsC;QACtC,iBAAiB;;IAErB;;IAEA;QACI,UAAU;QACV,YAAY;QACZ,kBAAkB;QAClB,sBAAsB;IAC1B;;IAEA;QACI,UAAU;QACV,aAAa;QACb,mBAAmB;QACnB,WAAW;QACX,iBAAiB;QACjB,gBAAgB;QAChB,0BAA0B;IAC9B;;IAEA;QACI,yBAAyB;QACzB,UAAU;QACV,aAAa;IACjB;;IAEA;QACI,UAAU;QACV,aAAa;QACb,SAAS;QACT,UAAU;IACd;;IAEA,uBAAuB;;IAEvB;QACI,YAAY;QACZ,0BAA0B;QAC1B,kBAAkB;QAClB,aAAa;QACb,mBAAmB;QACnB,2BAA2B;QAC3B,sBAAsB;QACtB,6BAA6B;QAC7B,eAAe;QACf,cAAc;QACd,gBAAgB;IACpB;;IAEA;QACI,YAAY;QACZ,0BAA0B;QAC1B,kBAAkB;QAClB,aAAa;QACb,mBAAmB;QACnB,2BAA2B;QAC3B,sBAAsB;QACtB,6BAA6B;QAC7B,eAAe;QACf,cAAc;QACd,gBAAgB;IACpB;;IAEA;QACI,YAAY;QACZ,0BAA0B;QAC1B,kBAAkB;QAClB,aAAa;QACb,mBAAmB;QACnB,2BAA2B;QAC3B,sBAAsB;QACtB,6BAA6B;QAC7B,eAAe;QACf,cAAc;QACd,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;QAClB,WAAW;IACf;;IAEA;QACI,YAAY;QACZ,aAAa;QACb,sBAAsB;QACtB,eAAe;QACf,cAAc;QACd,kBAAkB;QAClB,6BAA6B;;IAEjC;;IAEA;QACI,gBAAgB;QAChB,0BAA0B;QAC1B,cAAc;IAClB;;IAEA;QACI,YAAY;QACZ,aAAa;QACb,YAAY;QACZ,gBAAgB;QAChB,kBAAkB;QAClB,aAAa;QACb,uBAAuB;QACvB,sBAAsB;QACtB,6BAA6B;QAC7B,mBAAmB;QACnB,mBAAmB;QACnB,sBAAsB;IAC1B;;IAEA;;QAEI,aAAa;QACb,2BAA2B;QAC3B,eAAe;QACf,YAAY;QACZ,YAAY;QACZ,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,cAAc;QACd,UAAU;QACV,sBAAsB;QACtB,yBAAyB;IAC7B;;IAEA;QACI,UAAU;QACV,YAAY;QACZ,cAAc;QACd,sBAAsB;QACtB,yBAAyB;IAC7B;;IAEA;QACI,wBAAwB;QACxB,YAAY;QACZ,YAAY;QACZ,kBAAkB;QAClB,qBAAqB;QACrB,uBAAuB;QACvB,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;QAClB,YAAY;QACZ,UAAU;QACV,QAAQ;QACR,WAAW;QACX,YAAY;QACZ,kCAAkC;IACtC;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,gBAAgB;QAChB,YAAY;QACZ,yBAAyB;QACzB,kBAAkB;QAClB,eAAe;QACf,YAAY;QACZ,kBAAkB;QAClB,cAAc;QACd,sBAAsB;IAC1B;;IAEA,SAAS;;IAET;QACI,oBAAoB;IACxB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;QAClB,QAAQ;QACR,QAAQ;QACR,aAAa;QACb,kBAAkB;QAClB,kCAAkC;QAClC,sBAAsB;QACtB,eAAe;IACnB;;IAEA;QACI,cAAc;QACd,qBAAqB;QACrB,4BAA4B;QAC5B,2BAA2B;QAC3B,wBAAwB;IAC5B;;;;AAIJ;;AAEA;;IAEI;QACI,gBAAgB;QAChB,qBAAqB;QACrB,sBAAsB;QACtB,WAAW;QACX,YAAY;QACZ,sCAAsC;QACtC,iBAAiB;QACjB,aAAa;IACjB;;IAEA;QACI,WAAW;QACX,gBAAgB;QAChB,gBAAgB;QAChB,YAAY;QACZ,kBAAkB;QAClB,sBAAsB;IAC1B;;IAEA;;QAEI,WAAW;QACX,aAAa;QACb,mBAAmB;QACnB,WAAW;QACX,iBAAiB;QACjB,gBAAgB;QAChB,0BAA0B;IAC9B;;IAEA;QACI,yBAAyB;QACzB,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,YAAY;QACZ,aAAa;QACb,SAAS;QACT,UAAU;IACd;;IAEA,uBAAuB;;IAEvB;QACI,YAAY;QACZ,0BAA0B;QAC1B,kBAAkB;QAClB,aAAa;QACb,mBAAmB;QACnB,2BAA2B;QAC3B,sBAAsB;QACtB,6BAA6B;QAC7B,eAAe;QACf,cAAc;QACd,gBAAgB;IACpB;;IAEA;QACI,YAAY;QACZ,0BAA0B;QAC1B,kBAAkB;QAClB,aAAa;QACb,mBAAmB;QACnB,2BAA2B;QAC3B,sBAAsB;QACtB,6BAA6B;QAC7B,eAAe;QACf,cAAc;QACd,gBAAgB;IACpB;;IAEA;QACI,YAAY;QACZ,0BAA0B;QAC1B,kBAAkB;QAClB,aAAa;QACb,mBAAmB;QACnB,2BAA2B;QAC3B,sBAAsB;QACtB,6BAA6B;QAC7B,eAAe;QACf,cAAc;QACd,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;QAClB,WAAW;IACf;;;;IAIA;QACI,YAAY;QACZ,aAAa;QACb,sBAAsB;QACtB,eAAe;QACf,cAAc;QACd,kBAAkB;QAClB,6BAA6B;;IAEjC;;IAEA;QACI,gBAAgB;QAChB,0BAA0B;QAC1B,cAAc;IAClB;;IAEA;QACI,YAAY;QACZ,aAAa;QACb,YAAY;QACZ,gBAAgB;QAChB,kBAAkB;QAClB,aAAa;QACb,uBAAuB;QACvB,sBAAsB;QACtB,6BAA6B;QAC7B,mBAAmB;QACnB,mBAAmB;QACnB,sBAAsB;IAC1B;;IAEA;;QAEI,aAAa;QACb,2BAA2B;QAC3B,eAAe;QACf,YAAY;QACZ,YAAY;QACZ,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,cAAc;QACd,UAAU;QACV,sBAAsB;QACtB,yBAAyB;IAC7B;;IAEA;QACI,UAAU;QACV,YAAY;QACZ,cAAc;QACd,sBAAsB;QACtB,yBAAyB;IAC7B;;IAEA;QACI,wBAAwB;QACxB,YAAY;QACZ,YAAY;QACZ,kBAAkB;QAClB,qBAAqB;QACrB,4CAA4C;QAC5C,kBAAkB;QAClB,+CAA+C;IACnD;;IAEA;QACI,kBAAkB;IACtB;;IAEA,oBAAoB;;IAEpB;QACI,kBAAkB;QAClB,YAAY;QACZ,UAAU;QACV,QAAQ;QACR,WAAW;QACX,YAAY;QACZ,kCAAkC;IACtC;;IAEA;QACI,kBAAkB;QAClB,QAAQ;QACR,QAAQ;QACR,WAAW;QACX,YAAY;QACZ,gBAAgB;QAChB,aAAa;QACb,UAAU;QACV,qCAAqC;QAErC,6BAA6B;IACjC;;;IAGA;QACI,WAAW;QACX,YAAY;QACZ,gBAAgB;QAChB,YAAY;QACZ,yBAAyB;QACzB,kBAAkB;QAClB,eAAe;QACf,YAAY;QACZ,kBAAkB;QAClB,cAAc;QACd,sBAAsB;IAC1B;;IAEA;QACI,mCAAmC;QACnC,eAAe;IACnB;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,kBAAkB;QAClB,OAAO;QACP,QAAQ;QACR,kCAAkC;QAClC,WAAW;IACf;;IAEA;QACI,cAAc;IAClB;;IAEA,UAAU;;IAEV;QACI,oBAAoB;IACxB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;QAChB,kBAAkB;QAClB,aAAa;QACb,2BAA2B;QAC3B,mBAAmB;QACnB,gBAAgB;QAChB,mBAAmB;QACnB,eAAe;QACf,sBAAsB;IAC1B;;IAEA;QACI,kBAAkB;QAClB,QAAQ;QACR,QAAQ;QACR,aAAa;QACb,kBAAkB;QAClB,kCAAkC;QAClC,sBAAsB;QACtB,eAAe;IACnB;;IAEA;QACI,cAAc;QACd,qBAAqB;QACrB,4BAA4B;QAC5B,2BAA2B;QAC3B,wBAAwB;IAC5B;;AAEJ","sourcesContent":["/* Header css */\r\n\r\n:root {\r\n    --bg-oficial: #b4a45b;\r\n    --font-body: 'Kanit', sans-serif;\r\n}\r\n\r\n.activenav:hover {\r\n    color: #69E4FF;\r\n}\r\n\r\n.container-main {\r\n    background-color: #ffffff;\r\n    /* Background color for the container */\r\n    margin: 4%;\r\n    padding: 2%;\r\n    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);\r\n    margin-left: 10%;\r\n    height: auto;\r\n    background-image: linear-gradient(#E6E8EA, rgb(255, 255, 255));\r\n    border-radius: 10px;\r\n}\r\n.forgot-password {\r\n    color: blue; /* ตัวหนังสือเป็นสีน้ำเงิน */\r\n    cursor: pointer;\r\n    width: 35%;\r\n    height: 21px;\r\n    text-decoration: none; /* ปิดเส้นใต้ปกติ */\r\n    transition: color 0.01s ease-in-out, text-decoration 0.01s ease-in-out;\r\n  }\r\n  \r\n  .forgot-password:hover {\r\n    color: lightblue; /* เปลี่ยนเป็นสีอ่อนลงเมื่อ hover */\r\n    text-decoration: underline; /* เพิ่มเส้นใต้เมื่อ hover */\r\n  }\r\n.bd-navbar {\r\n    min-height: 0rem;\r\n    background-color: var(--bg-oficial);\r\n    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, .05), inset 0 -1px 0 rgba(0, 0, 0, .1);\r\n    padding-top: 2em;\r\n    padding-bottom: .5em;\r\n\r\n}\r\n\r\n.title-navbar {\r\n    font-family: var(--font-body);\r\n    font-weight: 800;\r\n    font-size: 45px;\r\n}\r\n\r\n.subtitle-section {\r\n    color: var(--bg-oficial);\r\n    font-family: var(--font-body);\r\n    font-weight: 600;\r\n    font-size: 25px;\r\n}\r\n\r\n.subtitle-card {\r\n    font-family: var(--font-body);\r\n    font-weight: 600;\r\n    font-size: 25px;\r\n}\r\n\r\n.text-center {\r\n    text-align: center;\r\n}\r\n\r\n.container-general {\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n\r\n.section-container {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    flex-direction: column;\r\n    border: 1px solid #c8c8c8;\r\n}\r\n\r\n.section-left {\r\n    border-bottom-left-radius: 16px;\r\n}\r\n\r\n.section-right {\r\n    border-bottom-right-radius: 16px;\r\n}\r\n\r\n.container-box {\r\n    padding-left: 0;\r\n    padding-right: 0;\r\n}\r\n\r\n.form-element {\r\n    margin: 5px;\r\n    min-width: 200px;\r\n}\r\n\r\n\r\n/*.form-control {\r\n    width: 238px;\r\n    display: block;\r\n    border: 1px solid #C4B4B4;\r\n    border-radius: 20px;\r\n    height: 38px;\r\n    padding: 5px 10px 5px 40px;\r\n    \r\n}*/\r\n\r\n.form-box {\r\n    width: 100%;\r\n    max-width: 285px;\r\n    border-radius: 10px;\r\n}\r\n\r\n.form-label {\r\n    min-width: 150px;\r\n    display: block;\r\n    font-family: var(--font-body);\r\n    font-weight: 600;\r\n}\r\n\r\n.input-display {\r\n    display: inline-block;\r\n    border: 1px solid #C4B4B4;\r\n    border-radius: 10px;\r\n    height: 40px;\r\n    padding: 5px 10px 5px 15px;\r\n}\r\n\r\n.font-icon {\r\n    position: relative;\r\n\r\n}\r\n\r\n.font-icon i {\r\n    position: absolute;\r\n    left: 15px;\r\n    top: 45px;\r\n    color: #000;\r\n\r\n}\r\n\r\n.font-icon1 {\r\n    font-size: 60px;\r\n\r\n\r\n}\r\n\r\n.btn-generate {\r\n    border: none;\r\n    border-radius: 10px;\r\n    background-color: var(--bg-oficial);\r\n    color: #fff;\r\n    font-family: var(--font-body);\r\n    font-weight: bold;\r\n    padding: .5em;\r\n    margin-top: 1em;\r\n}\r\n\r\n.id-card-container {\r\n    display: none;\r\n}\r\n\r\n.card-container {\r\n    width: 90vw;\r\n    height: 300px;\r\n    border-radius: 10px;\r\n    font-family: var(--font-body);\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.card-title {\r\n    font-size: 16px;\r\n    color: #BABFC9;\r\n    font-weight: bold;\r\n}\r\n\r\n.card-input {\r\n    font-size: 16px;\r\n    color: #515A67;\r\n    font-weight: bold;\r\n}\r\n\r\n.card-input1 {\r\n    font-size: 28px;\r\n    color: #515A67;\r\n    font-weight: bold;\r\n    padding: 5px 10px 5px 10px;\r\n\r\n\r\n}\r\n\r\n.card-wrapper {\r\n    width: 80vw;\r\n    height: 250px;\r\n    background-color: #fff;\r\n    background: linear-gradient(#f8f8f8, #fff);\r\n    box-shadow: 0 8px 16px -8px rgba(0, 0, 0, 0.4);\r\n    border-radius: 10px;\r\n    overflow: hidden;\r\n    position: relative;\r\n    margin: 1.5rem;\r\n    display: flex;\r\n}\r\n\r\n.user-card {\r\n    width: 30vw;\r\n    height: 100%;\r\n    position: relative;\r\n    background: linear-gradient(to top, var(--bg-oficial), #8f94fb);\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n\r\n.general-information {\r\n    width: 60vw;\r\n    height: 100%;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    background-color: #F8F8F8;\r\n}\r\n\r\n.user-photo {\r\n    font-size: 10em;\r\n    color: white;\r\n}\r\n\r\n.card-element {\r\n    margin-left: 10px;\r\n    margin-bottom: 15px;\r\n}\r\n\r\n.card-name {\r\n    font-size: 1.5rem;\r\n}\r\n\r\n.college-name {\r\n    font-size: 1.2rem;\r\n}\r\n\r\n.font-cen {\r\n    font-Family: \"Kanit\"\r\n}\r\n\r\n.backgroundbase {\r\n    /* background: linear-gradient(94.35deg, #023E8A 0%, #0077B6 100%); */\r\n}\r\n\r\n.build-button-border {\r\n\r\n    padding: 1rem;\r\n    position: relative;\r\n    background: linear-gradient(101.27deg, #E01E37 0%, #FF792B 100%);\r\n    padding: 3px;\r\n}\r\n\r\n.buildbutton {\r\n    background: #E6E8EA;\r\n    color: black;\r\n\r\n}\r\n\r\n\r\n.btnlogin {\r\n    top: 420px;\r\n    left: 25px;\r\n    width: 350px;\r\n    height: 60px;\r\n    border-radius: 100px;\r\n    background-color: #023E8A;\r\n    color: #FFFFFF;\r\n    font-size: 26px;\r\n    opacity: 0.6;\r\n    transition: 0.3s;\r\n}\r\n\r\n.btnlogin:hover {\r\n    opacity: 1\r\n}\r\n\r\n\r\n\r\n\r\n.frame {\r\n    width: 90%;\r\n    margin: 40px auto;\r\n    text-align: center;\r\n}\r\n\r\n.custom-btn {\r\n\r\n    color: #fff;\r\n    border-radius: 5px;\r\n    padding: 10px 25px;\r\n    font-family: 'Lato', sans-serif;\r\n    font-weight: 500;\r\n    background: transparent;\r\n    cursor: pointer;\r\n    transition: all 0.3s ease;\r\n    position: relative;\r\n    display: inline-block;\r\n    box-shadow: inset 2px 2px 2px 0px rgba(255, 255, 255, .5),\r\n        7px 7px 20px 0px rgba(0, 0, 0, .1),\r\n        4px 4px 5px 0px rgba(0, 0, 0, .1);\r\n    outline: none;\r\n}\r\n\r\n.btnSave {\r\n    background-image: linear-gradient(90deg, #61028a 0%, #5d00c7 100%);\r\n    border: none;\r\n    z-index: 1;\r\n    opacity: 0.85;\r\n    font-family: Kanit;\r\n    font-size: 20px;\r\n    border-radius: 25px;\r\n}\r\n\r\n.btnConfirm {\r\n    background-image: linear-gradient(90deg, #006e1a 0%, #01b34b 100%);\r\n    border: none;\r\n    z-index: 1;\r\n    opacity: 0.85;\r\n    font-family: Kanit;\r\n    font-size: 20px;\r\n    border-radius: 25px;\r\n}\r\n\r\n.btnCancel {\r\n    background-image: linear-gradient(97.41deg, #a50104 0%, #ff792b 100%);\r\n    border: none;\r\n    z-index: 1;\r\n    opacity: 0.85;\r\n    font-family: Kanit;\r\n    font-size: 20px;\r\n    border-radius: 25px;\r\n}\r\n\r\n.btnEdit2 {\r\n    background-image: linear-gradient(97.29deg, #ffb300 0%, #ffe923 100%);\r\n    border: none;\r\n    z-index: 1;\r\n    opacity: 0.85;\r\n    font-family: Kanit;\r\n    font-size: 20px;\r\n    border-radius: 25px;\r\n}\r\n\r\n.btnDisable {\r\n    background-image: linear-gradient(90.27deg, rgb(182, 182, 182) 0.23%, rgb(119, 119, 119) 99.42%);\r\n    border: none;\r\n    z-index: 1;\r\n    opacity: 0.85;\r\n    font-family: Kanit;\r\n    font-size: 20px;\r\n    border-radius: 25px;\r\n}\r\n\r\n.btnSave:after {\r\n    position: absolute;\r\n    content: \"\";\r\n    width: 0;\r\n    height: 100%;\r\n    top: 0;\r\n    right: 0;\r\n    z-index: -1;\r\n    background-image: linear-gradient(90deg, #61028a36 0%, #5d00c742 100%);\r\n    border-radius: 25px;\r\n    box-shadow: inset 2px 2px 2px 0px rgba(255, 255, 255, .5),\r\n        7px 7px 20px 0px rgba(0, 0, 0, .1),\r\n        4px 4px 5px 0px rgba(0, 0, 0, .1);\r\n    transition: all 0.3s ease;\r\n\r\n}\r\n\r\n.btnConfirm:after {\r\n    position: absolute;\r\n    content: \"\";\r\n    width: 0;\r\n    height: 100%;\r\n    top: 0;\r\n    right: 0;\r\n    z-index: -1;\r\n    background-image: linear-gradient(90deg, #01b34b 0%, #006e1a 100%);\r\n    border-radius: 25px;\r\n    box-shadow: inset 2px 2px 2px 0px rgba(255, 255, 255, .5),\r\n        7px 7px 20px 0px rgba(0, 0, 0, .1),\r\n        4px 4px 5px 0px rgba(0, 0, 0, .1);\r\n    transition: all 0.3s ease;\r\n\r\n}\r\n\r\n.btnCancel:after {\r\n    background-image: linear-gradient(97.41deg, #a50104 0%, #ff792b 100%);\r\n    position: absolute;\r\n    content: \"\";\r\n    width: 0;\r\n    height: 100%;\r\n    top: 0;\r\n    right: 0;\r\n    z-index: -1;\r\n    border-radius: 25px;\r\n    box-shadow: inset 2px 2px 2px 0px rgba(255, 255, 255, .5),\r\n        7px 7px 20px 0px rgba(0, 0, 0, .1),\r\n        4px 4px 5px 0px rgba(0, 0, 0, .1);\r\n    transition: all 0.3s ease;\r\n\r\n}\r\n\r\n.btnEdit2:after {\r\n    background-image: linear-gradient(97.29deg, #ffb710 0%, #ffeb34 100%);\r\n    position: absolute;\r\n    content: \"\";\r\n    width: 0;\r\n    height: 100%;\r\n    top: 0;\r\n    right: 0;\r\n    z-index: -1;\r\n    border-radius: 25px;\r\n    box-shadow: inset 2px 2px 2px 0px rgba(255, 255, 255, .5),\r\n        7px 7px 20px 0px rgba(0, 0, 0, .1),\r\n        4px 4px 5px 0px rgba(0, 0, 0, .1);\r\n    transition: all 0.3s ease;\r\n}\r\n\r\n.btnSave:hover {\r\n    color: #ffffff;\r\n    opacity: 1;\r\n    border-radius: 25px;\r\n}\r\n\r\n.btnConfirm:hover {\r\n    color: #ffffff;\r\n    opacity: 1;\r\n    border-radius: 25px;\r\n}\r\n\r\n.btnCancel:hover {\r\n    color: #ffffff;\r\n    opacity: 1;\r\n    border-radius: 25px;\r\n}\r\n\r\n.btnEdit2:hover {\r\n    color: #ffffff;\r\n    opacity: 1;\r\n    border-radius: 25px;\r\n}\r\n\r\n.btnSave:hover:after {\r\n    left: 0;\r\n    width: 100%;\r\n}\r\n\r\n.btnConfirm:hover:after {\r\n    left: 0;\r\n    width: 100%;\r\n}\r\n\r\n.btnCancel:hover:after {\r\n    left: 0;\r\n    width: 100%;\r\n}\r\n\r\n.btnEdit2:hover:after {\r\n    left: 0;\r\n    width: 100%;\r\n}\r\n\r\n.btnSave:active {\r\n    top: 2px;\r\n}\r\n\r\n.btnConfirm:active {\r\n    top: 2px;\r\n}\r\n\r\n.btnCancel:active {\r\n    top: 2px;\r\n}\r\n\r\n.btnEdit2:active {\r\n    top: 2px;\r\n}\r\n\r\n\r\n\r\n.dropdown {\r\n\r\n    transition-duration: 0.7s;\r\n    transition-delay: 0.3;\r\n\r\n}\r\n\r\n.dropdown-content {\r\n    display: none;\r\n    position: absolute;\r\n    background-color: #f70a0a;\r\n    min-width: 160px;\r\n    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);\r\n    padding: 12px 16px;\r\n    z-index: 1;\r\n}\r\n\r\n.dropdown:hover .dropdown-content {\r\n    display: block;\r\n    background-color: #f70a0a;\r\n}\r\n\r\ndiv .nav-section {\r\n    color: #fff;\r\n    /* Link text color */\r\n    text-decoration: none;\r\n    /* Remove default underline */\r\n    display: inline-block;\r\n}\r\n\r\ndiv .nav-section:hover {\r\n    border-bottom: 3.5px solid white;\r\n    /* White line at the bottom */\r\n}\r\n\r\n.logo-text {\r\n    color: #ffffff;\r\n    font-family: 'Kanit';\r\n    font-style: normal;\r\n    font-weight: 700;\r\n    font-size: 36px;\r\n    line-height: 40px;\r\n    padding-top: 3px;\r\n}\r\n\r\n.logo-text:hover {\r\n    color: #7edcfc;\r\n}\r\n\r\n.card-box-login {\r\n    top: 100px;\r\n    width: 420px;\r\n    height: auto;\r\n    font-family: 'Kanit';\r\n    padding: 20px 25px 30px;\r\n    border-radius: 20px;\r\n    background: white;\r\n}\r\n\r\n.main-bg {\r\n    background: url(\"../../picture/download.avif\");\r\n    object-fit: cover;\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n    display: flex;\r\n    width: 100%;\r\n    height: 93.25vh;\r\n    background-attachment: scroll;\r\n    min-width: 980px;\r\n}\r\n\r\n.carousel-element {\r\n    float: center;\r\n    margin-top: 300px;\r\n    background-color: white;\r\n    width: 60%;\r\n}\r\n\r\n.center-box {\r\n    margin-top: 5%;\r\n    margin-left: 10%;\r\n    margin-right: 10%;\r\n    margin-bottom: 5%;\r\n    align-items: center;\r\n    width: 90%;\r\n    height: auto;\r\n    padding: 2%;\r\n    background-color: rgba(46, 46, 46, 0.5);\r\n    border-radius: 20px;\r\n    max-height: 820px;\r\n\r\n}\r\n\r\n.center-text {\r\n    color: white;\r\n    margin: auto;\r\n    font-size: 16px;\r\n    padding-top: 2%;\r\n    padding-left: 15%;\r\n    padding-right: 15%;\r\n    width: 100%;\r\n    height: 100%;\r\n    background-color: rgba(58, 58, 58, 0);\r\n\r\n}\r\n\r\n.center-carousel-main {\r\n    width: auto;\r\n    height: 105%;\r\n    margin-bottom: 5%;\r\n    margin-left: 4%;\r\n    display: flex;\r\n}\r\n\r\n.center-img {\r\n    background: url('/src/picture/AMETHYST-LOGO-removebg-preview.png');\r\n    background-size: cover;\r\n    background-position: center center;\r\n    transform: translate(0%, 0%);\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n    margin-bottom: 20px;\r\n    display: flex;\r\n    width: 300px;\r\n    height: 110px;\r\n    background-attachment: scroll;\r\n}\r\n\r\n.center-img img {\r\n    max-width: 100%;\r\n    max-height: 100%;\r\n    object-fit: contain;\r\n}\r\n\r\n.loading-container {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    height: 85vh;\r\n}\r\n\r\n.check-box {\r\n    color: black;\r\n\r\n}\r\n\r\n.check-box:hover {\r\n    color: gray;\r\n}\r\n\r\ndiv.card-noti-content {\r\n    margin: 10px 25px;\r\n}\r\n\r\ndiv.card-noti-header {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    /* Distribute items along the main axis */\r\n    align-items: center;\r\n    margin: 10px 2px;\r\n    color: white;\r\n}\r\n\r\n.card-noti-header h5 {\r\n    margin: 0;\r\n    /* Remove default margin */\r\n    text-align: center;\r\n    /* Center text horizontally */\r\n    flex: 1;\r\n    /* Allow the h5 element to grow and fill available space */\r\n}\r\n\r\n.bin-icon {\r\n    width: 25px;\r\n    height: 25px;\r\n    cursor: pointer;\r\n    color: black;\r\n    transition: 0.7s;\r\n}\r\n\r\n.bin-icon:hover {\r\n    color: white;\r\n    transition: 0.7s;\r\n}\r\n\r\n.card-noti-box {\r\n    position: fixed;\r\n    bottom: 60px;\r\n    right: 50px;\r\n    margin: auto;\r\n    width: 400px;\r\n    height: auto;\r\n    min-height: 8vh;\r\n    max-height: 40vh;\r\n    overflow-y: auto;\r\n    overflow-x: hidden;\r\n    background-color: #60dfff;\r\n    background: linear-gradient(90.27deg, rgb(2, 62, 138) 0.23%, rgb(0, 150, 199) 99.42%);\r\n    box-shadow: 0 8px 10px 3px rgba(0, 0, 0, 0.4);\r\n    border-radius: 15px;\r\n    transition: 0.3s ease-in-out;\r\n    z-index: 100;\r\n\r\n}\r\n\r\n.noti-bell-box {\r\n    margin: 12px 50px 0px 0px;\r\n    cursor: pointer;\r\n    position: fixed;\r\n    bottom: 10px;\r\n    right: -30px;\r\n    background-color: rgb(255, 255, 255);\r\n    padding: 10px 20px;\r\n    border-radius: 5px;\r\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\r\n    z-index: 100;\r\n}\r\n\r\n.noti-bell-box:hover .noti-bell-span,\r\n.noti-bell-box:hover .noti-bell {\r\n    color: #7edcfc;\r\n}\r\n\r\n.notification-item.removing {\r\n    transition: 0.5s ease-in-out;\r\n    /* Example transition */\r\n    opacity: 0;\r\n    /* Fade out the item */\r\n}\r\n\r\n.noti-bell {\r\n    width: 25px;\r\n    height: 25px;\r\n    color: rgb(51, 103, 170);\r\n    z-index: 0;\r\n    transition: 0.5s;\r\n}\r\n\r\n.noti-bell-span {\r\n    position: absolute;\r\n    width: 16px;\r\n    height: 16px;\r\n    border-radius: 50%;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    color: white;\r\n    background-color: red;\r\n    font-size: 10px;\r\n    z-index: 1;\r\n}\r\n\r\n\r\n::-webkit-scrollbar {\r\n    width: 7px;\r\n}\r\n\r\n::-webkit-scrollbar-thumb {\r\n    background-color: #888;\r\n    border-radius: 5px;\r\n}\r\n\r\n\r\n@media screen and (max-width: 1180px) {\r\n\r\n    .profile-container {\r\n        box-sizing: border-box;\r\n        width: auto;\r\n        height: auto;\r\n        min-height: calc(100vh - 230px - 35px);\r\n        max-width: 1230px;\r\n\r\n    }\r\n\r\n    .article-content {\r\n        width: 80%;\r\n        float: right;\r\n        position: relative;\r\n        box-sizing: border-box;\r\n    }\r\n\r\n    .profile-side-nav {\r\n        width: 20%;\r\n        height: 482px;\r\n        margin-top: 161.5px;\r\n        float: left;\r\n        background: white;\r\n        max-width: 280px;\r\n        border-top: 2px solid #555;\r\n    }\r\n\r\n    .nav-side-body {\r\n        background-color: #E6E8EA;\r\n        width: 20%;\r\n        height: 484px;\r\n    }\r\n\r\n    .nav-side-menu {\r\n        width: 20%;\r\n        height: 482px;\r\n        margin: 0;\r\n        padding: 0;\r\n    }\r\n\r\n    .nav-sidemenu-display {}\r\n\r\n    .nav-sidemenu-selection {\r\n        height: 45px;\r\n        padding: 0px 36px 0px 20px;\r\n        position: relative;\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: flex-start;\r\n        box-sizing: border-box;\r\n        border-top: 1px solid #dfdfdf;\r\n        font-size: 16px;\r\n        color: #0077B6;\r\n        font-weight: 400;\r\n    }\r\n\r\n    .nav-sidemenu-selection:hover {\r\n        height: 45px;\r\n        padding: 0px 36px 0px 20px;\r\n        position: relative;\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: flex-start;\r\n        box-sizing: border-box;\r\n        border-top: 1px solid #dfdfdf;\r\n        font-size: 16px;\r\n        color: #4d6368;\r\n        font-weight: 400;\r\n    }\r\n\r\n    .nav-sidemenu-selection:active {\r\n        height: 45px;\r\n        padding: 0px 36px 0px 20px;\r\n        position: relative;\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: flex-start;\r\n        box-sizing: border-box;\r\n        border-top: 1px solid #dfdfdf;\r\n        font-size: 16px;\r\n        color: #4d6368;\r\n        font-weight: 400;\r\n    }\r\n\r\n    li {\r\n        list-style: none;\r\n    }\r\n\r\n    i {\r\n        margin-right: 18px;\r\n        width: 30px;\r\n    }\r\n\r\n    .profile-header {\r\n        width: 880px;\r\n        height: 163px;\r\n        padding: 65px 0px 42px;\r\n        font-size: 45px;\r\n        color: #0077B6;\r\n        text-align: center;\r\n        border-bottom: 2px solid #555;\r\n\r\n    }\r\n\r\n    .user-main {\r\n        margin-top: 20px;\r\n        color: rgba(60, 60, 60, 1);\r\n        display: block;\r\n    }\r\n\r\n    .user-wrap {\r\n        width: 580px;\r\n        height: 135px;\r\n        color: white;\r\n        background: #000;\r\n        position: relative;\r\n        display: flex;\r\n        justify-content: center;\r\n        flex-direction: column;\r\n        padding: 22px 30px 22px 160px;\r\n        border-radius: 15px;\r\n        background: #353942;\r\n        box-sizing: border-box;\r\n    }\r\n\r\n    .user-deshboard {\r\n\r\n        display: flex;\r\n        justify-content: flex-start;\r\n        flex-wrap: wrap;\r\n        width: 880px;\r\n        height: auto;\r\n        margin-top: 18px;\r\n    }\r\n\r\n    .user-desh-left {\r\n        float: left;\r\n        display: block;\r\n        width: 50%;\r\n        box-sizing: border-box;\r\n        padding: 0px 10px 0px 0px;\r\n    }\r\n\r\n    .user-desh-right {\r\n        width: 50%;\r\n        float: right;\r\n        display: block;\r\n        box-sizing: border-box;\r\n        padding: 0px 0px 0px 10px;\r\n    }\r\n\r\n    .user-desh-box {\r\n        vertical-align: baseline;\r\n        width: 430px;\r\n        height: auto;\r\n        padding: 25px 29px;\r\n        min-inline-size: auto;\r\n        background-color: white;\r\n        border-radius: 6px;\r\n    }\r\n\r\n    .user-icon {\r\n        position: absolute;\r\n        margin: auto;\r\n        left: 45px;\r\n        top: 50%;\r\n        width: 80px;\r\n        height: 80px;\r\n        transform: translate3d(0, -50%, 0);\r\n    }\r\n\r\n    .icon-character {\r\n        width: 100%;\r\n        height: 100%;\r\n        margin-top: 10px;\r\n        margin: auto;\r\n        background-color: #023E8A;\r\n        text-align: center;\r\n        font-size: 50px;\r\n        color: white;\r\n        border-radius: 50%;\r\n        display: block;\r\n        box-sizing: border-box;\r\n    }\r\n\r\n    .acount {}\r\n\r\n    .logged {\r\n        margin: 18px 0px 0px;\r\n    }\r\n\r\n    .secure {\r\n        margin: 18px 0px 0px;\r\n    }\r\n\r\n    .secure_list {\r\n        margin-top: 5px;\r\n        padding-left: 5px;\r\n        overflow: hidden;\r\n    }\r\n\r\n    .secure_list .item {\r\n        font-size: 0.92rem;\r\n    }\r\n\r\n    .secure_list .btn_secure {\r\n        position: absolute;\r\n        right: 0;\r\n        top: 50%;\r\n        display: flex;\r\n        border-radius: 50%;\r\n        transform: translate3d(0, -50%, 0);\r\n        box-sizing: border-box;\r\n        cursor: default;\r\n    }\r\n\r\n    .icn_svg {\r\n        flex: 0 0 auto;\r\n        display: inline-block;\r\n        background-repeat: no-repeat;\r\n        background-position: center;\r\n        background-size: contain;\r\n    }\r\n\r\n    \r\n\r\n}\r\n\r\n@media screen and (min-width: 1180px) {\r\n\r\n    .profile-container {\r\n        margin: 0px auto;\r\n        padding: 0px 0px 80px;\r\n        box-sizing: border-box;\r\n        width: auto;\r\n        height: auto;\r\n        min-height: calc(100vh - 230px - 35px);\r\n        max-width: 1230px;\r\n        display: flex;\r\n    }\r\n\r\n    .article-content {\r\n        width: 100%;\r\n        max-width: 880px;\r\n        margin: 0px auto;\r\n        float: right;\r\n        position: relative;\r\n        box-sizing: border-box;\r\n    }\r\n\r\n    .profile-side-nav {\r\n\r\n        width: auto;\r\n        height: 482px;\r\n        margin-top: 161.5px;\r\n        float: left;\r\n        background: white;\r\n        max-width: 280px;\r\n        border-top: 2px solid #555;\r\n    }\r\n\r\n    .nav-side-body {\r\n        background-color: #E6E8EA;\r\n        width: 280px;\r\n        height: 484px;\r\n    }\r\n\r\n    .nav-side-menu {\r\n        width: 280px;\r\n        height: 482px;\r\n        margin: 0;\r\n        padding: 0;\r\n    }\r\n\r\n    .nav-sidemenu-display {}\r\n\r\n    .nav-sidemenu-selection {\r\n        height: 45px;\r\n        padding: 0px 36px 0px 20px;\r\n        position: relative;\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: flex-start;\r\n        box-sizing: border-box;\r\n        border-top: 1px solid #dfdfdf;\r\n        font-size: 16px;\r\n        color: #0077B6;\r\n        font-weight: 400;\r\n    }\r\n\r\n    .nav-sidemenu-selection:hover {\r\n        height: 45px;\r\n        padding: 0px 36px 0px 20px;\r\n        position: relative;\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: flex-start;\r\n        box-sizing: border-box;\r\n        border-top: 1px solid #dfdfdf;\r\n        font-size: 16px;\r\n        color: #4d6368;\r\n        font-weight: 400;\r\n    }\r\n\r\n    .nav-sidemenu-selection:active {\r\n        height: 45px;\r\n        padding: 0px 36px 0px 20px;\r\n        position: relative;\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: flex-start;\r\n        box-sizing: border-box;\r\n        border-top: 1px solid #dfdfdf;\r\n        font-size: 16px;\r\n        color: #4d6368;\r\n        font-weight: 400;\r\n    }\r\n\r\n    li {\r\n        list-style: none;\r\n    }\r\n\r\n    i {\r\n        margin-right: 18px;\r\n        width: 30px;\r\n    }\r\n\r\n\r\n\r\n    .profile-header {\r\n        width: 880px;\r\n        height: 163px;\r\n        padding: 65px 0px 42px;\r\n        font-size: 45px;\r\n        color: #0077B6;\r\n        text-align: center;\r\n        border-bottom: 2px solid #555;\r\n\r\n    }\r\n\r\n    .user-main {\r\n        margin-top: 20px;\r\n        color: rgba(60, 60, 60, 1);\r\n        display: block;\r\n    }\r\n\r\n    .user-wrap {\r\n        width: 880px;\r\n        height: 135px;\r\n        color: white;\r\n        background: #000;\r\n        position: relative;\r\n        display: flex;\r\n        justify-content: center;\r\n        flex-direction: column;\r\n        padding: 22px 30px 22px 160px;\r\n        border-radius: 15px;\r\n        background: #353942;\r\n        box-sizing: border-box;\r\n    }\r\n\r\n    .user-deshboard {\r\n\r\n        display: flex;\r\n        justify-content: flex-start;\r\n        flex-wrap: wrap;\r\n        width: 880px;\r\n        height: auto;\r\n        margin-top: 18px;\r\n    }\r\n\r\n    .user-desh-left {\r\n        float: left;\r\n        display: block;\r\n        width: 50%;\r\n        box-sizing: border-box;\r\n        padding: 0px 10px 0px 0px;\r\n    }\r\n\r\n    .user-desh-right {\r\n        width: 50%;\r\n        float: right;\r\n        display: block;\r\n        box-sizing: border-box;\r\n        padding: 0px 0px 0px 10px;\r\n    }\r\n\r\n    .user-desh-box {\r\n        vertical-align: baseline;\r\n        width: 430px;\r\n        height: auto;\r\n        padding: 25px 29px;\r\n        min-inline-size: auto;\r\n        background-color: rgba(255, 255, 255, 0.658);\r\n        border-radius: 6px;\r\n        box-shadow: 0px 4px 7px 1px rgba(0, 0, 0, 0.12);\r\n    }\r\n\r\n    .user-desh-title {\r\n        position: relative;\r\n    }\r\n\r\n    .user-desh-content {}\r\n\r\n    .user-icon {\r\n        position: absolute;\r\n        margin: auto;\r\n        left: 45px;\r\n        top: 50%;\r\n        width: 80px;\r\n        height: 80px;\r\n        transform: translate3d(0, -50%, 0);\r\n    }\r\n\r\n    .btn-more {\r\n        position: absolute;\r\n        right: 0;\r\n        top: 50%;\r\n        width: 18px;\r\n        height: 10px;\r\n        padding: 8px 4px;\r\n        opacity: 0.65;\r\n        z-index: 5;\r\n        transform: translate3d(-15%, -50%, 0);\r\n        -webkit-transition: opacity .25s ease;\r\n        transition: opacity .25s ease;\r\n    }\r\n\r\n\r\n    .icon-character {\r\n        width: 100%;\r\n        height: 100%;\r\n        margin-top: 10px;\r\n        margin: auto;\r\n        background-color: #023E8A;\r\n        text-align: center;\r\n        font-size: 50px;\r\n        color: white;\r\n        border-radius: 50%;\r\n        display: block;\r\n        box-sizing: border-box;\r\n    }\r\n\r\n    .icon-edit {\r\n        transform: translate3d(0%, -15%, 0);\r\n        cursor: pointer;\r\n    }\r\n\r\n    .icon-edit:hover {\r\n        color: rgb(77, 99, 104);\r\n    }\r\n\r\n    .dash-more {\r\n        position: absolute;\r\n        left: 0;\r\n        top: 50%;\r\n        transform: translate3d(0, -50%, 0);\r\n        color: gray;\r\n    }\r\n\r\n    .dash-more:hover {\r\n        color: #0077B6;\r\n    }\r\n\r\n    .account {}\r\n\r\n    .logged {\r\n        margin: 18px 0px 0px;\r\n    }\r\n\r\n    .secure {\r\n        margin: 18px 0px 0px;\r\n    }\r\n\r\n    .secure_list {\r\n        margin-top: 5px;\r\n        padding-left: 5px;\r\n        overflow: hidden;\r\n    }\r\n\r\n    .secure_list .item {\r\n        margin-top: 15px;\r\n        position: relative;\r\n        display: flex;\r\n        justify-content: flex-start;\r\n        align-items: center;\r\n        min-height: 28px;\r\n        padding-right: 40px;\r\n        font-size: 18px;\r\n        box-sizing: border-box;\r\n    }\r\n\r\n    .secure_list .btn_secure {\r\n        position: absolute;\r\n        right: 0;\r\n        top: 50%;\r\n        display: flex;\r\n        border-radius: 50%;\r\n        transform: translate3d(0, -50%, 0);\r\n        box-sizing: border-box;\r\n        cursor: default;\r\n    }\r\n\r\n    .icn_svg {\r\n        flex: 0 0 auto;\r\n        display: inline-block;\r\n        background-repeat: no-repeat;\r\n        background-position: center;\r\n        background-size: contain;\r\n    }\r\n\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
